import React from 'react';
import PropTypes from 'prop-types';

const Field = props => {
  const type = props.type || "text";
  const className = props.className || "field";
  return (
    <div className={className}>
      <label className="label" htmlFor={props.id}>
        {props.label}
      </label>
      <input
        type={type}
        id={props.id}
        value={props.value}
        onChange={props.handleChange}
      />
    </div>
  );
};

Field.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  className: PropTypes.string
};

export default Field;